import {Component} from '@angular/core';
import {NavController ,ToastController} from 'ionic-angular';
import {Api} from "../../providers/api";
import {ItemsPage} from "../items/items";
import {CartPage} from "../cart/cart";
import {ItemPage} from "../item-details/item-details";
import {IMAGES_BASE_URL, LicenseName} from "../../providers/config";
import {CartManager} from "../../providers/cart-manager";
import {Constants} from '../../providers/config';
import {MyOrderPage} from '../my-order/my-order';
import {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import { Storage } from '@ionic/storage';
import {SearchPage} from '../search/search';
import * as moment from 'moment';
import {GVLogger} from "../../services/gv-logger";
import {CART} from "../../providers/data";

@Component({
  selector: 'page-bookmarks',
  templateUrl: 'bookmarks.html',
})
export class BookmarksPage {
  constants = Constants;
  isWebstore = 0;
  showNegative = false;

  searchQuery = " ";

  duration = 3;

  public cart : any;

  adpCustomerInfo:any = {};
  attributesPropertiesMap:any = new Map();
  items = new Map();
  baseImageUrl = IMAGES_BASE_URL;
  customerName = "";
// view type
private showList: boolean;
private products:any;
public viewType = "grid"

constructor(public nav: NavController,public api:Api,
    private cartManager:CartManager,
    public toastCtrl:ToastController,
    private storage:Storage,
    private msgManager:MsgManager,
    private gVLogger: GVLogger) {

  this.cart = CART;

      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.storage.get("negativeInventory").then((negativeInventory)=>{
     this.showNegative = negativeInventory;
   });

    if(Constants.isWebstore){
      this.isWebstore = 1;
    }


    this.storage.get("defaultLayout").then((defaultLayout)=>{
     this.viewType = defaultLayout;
   });

    this.customerName = this.cartManager.getCustomerName();
  	this.showList = true;

    let ev = {target:{
        value:" "
    }}

    this.searchThroughItems(ev);
    this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();

  }

 viewItem(item){
   this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
     if(data.status == "401"){ // check for session out
       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
       this.nav.setRoot(LoginPage);
     }
     if(data.status === "200"){
       item.description = data.data.description;
     }
   })
    this.nav.push(ItemPage, {item: item})
  }

   // go to search page
  goToSearch() {
    this.nav.push(SearchPage);
  }

searchThroughItems(ev: any){


    // Reset items back to all of the items
    // this.initializeCustomers();
    this.gVLogger.log(ev.target.value);
    // Show the results
    this.showList = true;
// set val to the value of the searchbar
    let val = ev.target.value;
    this.searchQuery = val;

    let params = {
      searchText: val,
      duration: this.duration
    }


this.items = new Map() ;
if(ev.target.value!=""){
  var url = "customers/likedProductsbyCustomer/"+this.cartManager.getCustomerID()+"/"+this.items.size;
    this.gVLogger.log(url+params);
    let cartItems = this.cartManager.getItems();
    // get list items of a category as sample
    this.api.get(url,params).map(res => res.json())
    .subscribe(result => {

      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else if(result.status == "200"){
         let map = new Map();

        map = this.items;
        if(this.attributesPropertiesMap.size === 0){
          this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
        }


        if(result.data){
          for ( let item of result.data){
            item.quantity = 0 ;
            map.set(item.id,item);

            if(LicenseName.indexOf(this.cartManager.getAdpCustomerInfo().licenseName) !== -1){
              let body = {"part" : item.barCode}
              this.api.post("proxy/part",body)
              .map(res=>res.json())
              .subscribe((result)=>{
                  if(result.status == "401"){ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                    this.nav.setRoot(LoginPage);
                  }
                item.stockLocations = result.data;
              },
              (err)=>{
                this.gVLogger.log(err);
              }
              );

            }
            else{
              item.stockLocations = false;
            }


            this.gVLogger.log("2 - "+ item.stockLocations);

            //Attribute map
            item.attributesList = [];
            this.gVLogger.log("iiiiteeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" + item.attributeSearch);

        // if(item.attributeSearch.indexOf('>') !== -1){
          if(item.attributeSearch !== -1 && item.attributeSearch != undefined){
          let tempAttributesList = item.attributeSearch.split('>');
          for(let attribute of tempAttributesList){
            this.gVLogger.log("map ==="+ this.attributesPropertiesMap);
            this.gVLogger.log("Value -- 1"+ this.attributesPropertiesMap.get(attribute.split(':')));
            this.gVLogger.log("Value -- 2"+ this.attributesPropertiesMap.get(attribute.split(':')[0]));
            this.gVLogger.log("Value -- 3"+ this.attributesPropertiesMap.get("58"));
            this.gVLogger.log("Value -- 4"+ this.attributesPropertiesMap.get(58));
            if(attribute!== "")
            item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
          }
        }
        item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
          }

        for(let cartItem of cartItems){
          if(map.has(cartItem.id)){
            map.set(cartItem.id,cartItem);
          }

        }

      }
        this.items = map;
        this.gVLogger.log("Products load on bookmark page load" + this.items);

    }
  });
  }else{
    this.items = new Map();
    let ev = {target:{
        value:" "
    }}

    this.searchThroughItems(ev);
  }
}

// checkValidDate(date){
//   this.gVLogger.log("----------------------before date.replace--------------------", date);
//   //date.replace(/^\s+|\s+$/gm,'-');
//   // this.gVLogger.log("1" + date.trim() + "1");
//   date = date.trim();
//   // date.splice(" ", "-");

//   this.gVLogger.log("----------------------daaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaate--------------------", date);

//   if(date === null ||  date === "" || date === "null"){
//     return false;
//   }
//   else{
//     return true;
//   }
// }


checkValidDate(date){

  if(moment(date, "DD-MM-YYYY").isValid()){
    return true;
  }
  else{
    return false;
  }


//   this.gVLogger.log("----------------------before date.replace--------------------", date);
//   //date.replace(/^\s+|\s+$/gm,'-');
//   // this.gVLogger.log("1" + date.trim() + "1");
//   if(date === undefined){
//     return false;
//   }
//   else{
//   date = date.trim();
//   // date.splice(" ", "-");

//   this.gVLogger.log("----------------------daaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaate--------------------", date);

//   if(date === null ||  date === "" || date === "null"){
//     return false;
//   }
//   else{
//     return true;
//   }
// }
}


  onCancel(ev) {
    // Show the results
    this.showList = false;

    // Reset the field
    ev.target.value = '';
  }

 addProductToCart(item){
  this.cartManager.addProductToCart(item);
}

removeProductFromCart(product){
  this.cartManager.removeOneNew(product);
}

updateProductInCart(product){
  if(String(product.quantity) !=""){
    if(String(product.quantity).match(/^\d+$/)){
      this.cartManager.updateCartNew(product);
    }else{
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      this.cartManager.updateCartNew(product);
    }
  }else{
      if (Number(product.minOrder) != 0) {
        product.quantity = Number(product.minOrder);
      } else {
        product.quantity = 1;
      }
      this.cartManager.updateCartNew(product);
  }


  }


imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }

  // switch to list view
  viewList() {
    this.viewType = 'list';
  }

  // swith to grid view
  viewGrid() {
    this.viewType = 'grid';
  }

  goToCart(){
    this.nav.push(CartPage);
  }


arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i].id === a[j].id)
                a.splice(j--, 1);
        }
    }

    return a;
}

// get discount percent
  discountPercent(originPrice, salePrice) {
    return Math.round((salePrice - originPrice) * 100 / originPrice)
  }


// updateItemQuantity(item){
//  var index= CART.items.map(function(x) {return x.id; }).indexOf(item.id);
//       if (index != -1) {
//           item.quantity = 0;
//       } else {
//           item.quantity = CART.items[index].quantity;
//       }
// }

discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }



  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage(){
  this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage(){
     this.nav.setRoot(MyOrderPage);
  }
  logOut(){
     this.nav.setRoot(LoginPage);
  }




bookmarkProduct(item){

  this.api.get("customers/likeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 1;
        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });
}

unBookmarkProduct(item){

  this.api.get("customers/dislikeProduct/"+this.cartManager.getCustomerID()+"/"+item.id)
  .map(res => res.json())
  .subscribe(result=>{

    if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }else if(result.status == 200){
         item.isWishlisted = 0;

         let ev = {target:{
        value:this.searchQuery
        }}


        this.searchThroughItems(ev);


        this.gVLogger.log("success");
      }

  },err=>{
    this.gVLogger.log(err);
  });

}


durationChanged(){

   let ev = {target:{
        value:this.searchQuery
    }}


  this.searchThroughItems(ev);
}


makeImageURL(dimensions,item){
  return this.cartManager.makeImageURL(dimensions,item);
}

getDateString(date){
  return new Date(date).toDateString();
}



}



// WEBPACK FOOTER //
// ./src/pages/bookmarks/bookmarks.ts